module.exports = __webpack_public_path__ + "img/19.69523922.jpg";